module.exports = __webpack_public_path__ + "static/advocacy-ab6d32525ff393b6d4e7f36ce566f109.webp";